/**
 * リクエストファイル削除時の確認ダイアログのPresentation Component
 */
import React from 'react';
import { Button, Popup, Title } from 'common/components';
import { BoardGL, Glossary } from 'common/utils/glossary';

interface ConfirmationBoardProps {
  /** ReqFileDeleteConfirmationBoardの表示有無 */
  isDisplay: boolean;
  /** グロッサリ */
  glossary: Glossary;
  /** "閉じるボタン"(×)、"いいえ(キャンセル)ボタン"の処理 */
  onClickClose: () => void;
  /** "はい(削除)ボタン"の処理 */
  onClickYes: () => void;
}

export const ReqFileDeleteConfirmationBoard: React.FC<ConfirmationBoardProps> = ({
  isDisplay,
  glossary,
  onClickClose,
  onClickYes
}) => {
  const _component = (
    <Popup
      className="reqFileDeleteConfirmationBoard-popup"
      onClickBackground={onClickClose}
      data-test="reqFileDeleteConfirmationBoard-popup"
      visible={isDisplay}
    >
      <div className="reqFileDeleteConfirmationBoard">
        <Button
          type="toolButton"
          subType="close"
          data-test="reqFileDeleteConfirmationBoard-toolButton"
          onClick={onClickClose}
        />
        <Title
          type="listMessage"
          data-test="reqFileDeleteConfirmationBoard-listMessage"
        >
          {glossary.glx(BoardGL.ReqFileDeleteConfirmation)}
        </Title>
        <div className="reqFileDeleteConfirmationBoard-buttonContainer">
          <Button
            type="okButton"
            data-test="reqFileDeleteConfirmationBoard-yesButton"
            onClick={onClickYes}
          >
            {glossary.glx(BoardGL.ReqFileDelete)}
          </Button>
          <Button
            type="cancelButton"
            data-test="reqFileDeleteConfirmationBoard-noButton"
            onClick={onClickClose}
          >
            {glossary.glx(BoardGL.Canceled)}
          </Button>
        </div>
      </div>
    </Popup>
  );
  return isDisplay ? _component : null;
};

export default ReqFileDeleteConfirmationBoard;
